import React from 'react';
import { Skeleton } from './skeleton';

export const SkeletonCircle: React.FC<SkeletonProps> = props => {
  return <Skeleton height={props.diameter} width={props.diameter} circle />;
};

interface SkeletonProps {
  diameter?: string | number;
}
